import api from "./api";

const financiadorService = {};
const endpoint = "/financiadores";

financiadorService.get = function () {
  return api.get(endpoint).then((res) => res.data);
};

export default financiadorService;
